<template>
  <div>
    <div class="d-flex align-items-center min-vh-100 container" >
      <div class="row justify-content-center" style="width: 100%;">
        <div class="col-md-8">
          <div class="card-group">
            <b-card class="p-4">
              <b-card-body>
                <h2>Reset Password</h2>
                <p v-if="!hasReset">To reset password enter the email you use to login!</p>
                <forgot-password-form v-if="!hasReset"  @success="onSuccess"/>
                <p v-if="hasReset" class="m-5">Please check your email. We have sent a reset link.</p>
              </b-card-body>
            </b-card>
            <div class="card text-center py-5 d-md-down-none bg-primary text-white" style="width: 44%;">
              <welcome-card/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ForgotPasswordForm from "../../components/users/ForgotPasswordForm";
  import WelcomeCard from "../../components/WelcomeCard";
  export default {
    name: 'ResetPassword',
    components: {
      WelcomeCard,
      ForgotPasswordForm,
    },
    data() {
      return {
        hasReset: false,
      }
    },
    methods: {
      onSuccess() {
        this.hasReset = true;
      }
    }
  }
</script>
